module.exports = __webpack_public_path__ + "static/media/irregular1.f7c5eae7.jpg";